export const environment = {
  production: false,
  api_url: 'https://api.flora-fitness.com/api',
};
